import { ErrorSimple, Loader } from '@scts-ui/component-library';
import { useConfigLoader } from '@scts/utilities';
import { useAppeals } from '../../utilities/appeals-query';
import { useParams } from 'react-router-dom';
import AppealComponent from '../../components/appeal/appeal-component';

const AppealParamManager = () => {
  const config = useConfigLoader();
  const params = useParams();

  const { data, isLoading, isIdle, isSuccess, isError } = useAppeals(
    config.data?.apiUrl ?? '',
    config.data?.configuration.auth.scopes ?? []
  );

  return (
    <>
      {(isLoading || isIdle) && <Loader loadingText={''} padding={'1rem'} />}
      {data && isSuccess && (
        <AppealComponent
          appeal={data.find(
            (appeal) => appeal.caseReference === params['appealId']
          )}
        />
      )}

      {isError && (
        <ErrorSimple
          icon="bi-exclamation-square-fill"
          margin="15% 30%"
          message="There has been an error contacting the server. Please try refreshing the page in the first instance, then logging out and back in again if necessary. If you continue to have issues then please contact support."
          padding="0.75rem"
          iconFontSize={'2.9rem'}
          textFontSize={'1rem'}
        />
      )}
    </>
  );
};

export default AppealParamManager;
